import { z } from "zod";
/**
 * Mood Check — no per-instance params. The daily mood entry and dismiss state
 * are user-local browser state (an allowed preference), never stored on the
 * placement.
 */
export const MoodCheckParamsSchema = z.object({}).strict();
export const defaultMoodCheckParams = {};
//# sourceMappingURL=moodCheck.js.map